// frontend/src/admin/blockforms/VideoCarouselForm.js
import React, { useState, useEffect } from 'react';
import { buildBlockSave } from './blockSaveTarget';

const API_BASE = process.env.REACT_APP_API_BASE || 'http://80.225.197.31:8001';


const VideoCarouselForm = ({ level, entityId, section,editingBlock, nextOrderIndex, onSaved, onCancel }) => {
    const existing = editingBlock?.content_data || {};
    const [orientation, setOrientation] = useState(existing.orientation || 'horizontal');

    const [videos, setVideos] = useState(existing.videos || []);
    const [newUrl, setNewUrl] = useState('');
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (videos.length === 0) return;

        const handleBeforeUnload = (e) => {
            e.preventDefault();
            e.returnValue = '';
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => window.removeEventListener('beforeunload', handleBeforeUnload);
    }, [videos]);

    const addVideo = () => {
        if (!newUrl.trim()) return;
        setVideos(prev => [...prev, { video_url: newUrl, en: { caption: '' }, hi: { caption: '' } }]);
        setNewUrl('');
    };

    const updateCaption = (index, lang, value) => {
        const updated = [...videos];
        updated[index] = { ...updated[index], [lang]: { caption: value } };
        setVideos(updated);
    };

    const removeVideo = (index) => {
        setVideos(videos.filter((_, i) => i !== index));
    };

    const moveVideo = (index, direction) => {
        const swapIndex = direction === 'up' ? index - 1 : index + 1;
        if (swapIndex < 0 || swapIndex >= videos.length) return;
        const updated = [...videos];
        [updated[index], updated[swapIndex]] = [updated[swapIndex], updated[index]];
        setVideos(updated);
    };

    const handleSave = async () => {
        if (videos.length === 0) {
            setError('Please add at least one video');
            return;
        }
        setError(null);
        setSaving(true);

        const content_data = { videos, orientation };

        const { url, method, payload } = buildBlockSave({
            level, entityId, section, editingBlock,
            blockType: 'video_carousel',
            contentData: content_data,
            orderIndex: nextOrderIndex,
        });

        try {
            const res = await fetch(url, {
                method,
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });
            if (!res.ok) {
                const err = await res.json();
                throw new Error(err.detail || 'Save failed');
            }
            onSaved();
        } catch (err) {
            setError(err.message);
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="ace-form">
            <h4>{editingBlock ? 'Edit' : 'Add'} Video Carousel</h4>
            {error && <div className="ace-error">{error}</div>}

            <label>Video Orientation</label>
            <select value={orientation} onChange={(e) => setOrientation(e.target.value)}>
                <option value="horizontal">Horizontal (landscape)</option>
                <option value="vertical">Vertical (portrait / Shorts)</option>
            </select>
            
            <label>Add Video URL (YouTube)</label>
            <div className="ace-table-row">
                <input type="text" value={newUrl} onChange={(e) => setNewUrl(e.target.value)} placeholder="https://youtube.com/watch?v=..." />
                <button type="button" onClick={addVideo}>+ Add</button>
            </div>

            {videos.map((vid, index) => (
                <div key={index} className="ace-table-editor">
                    <p className="ace-image-preview-path">{vid.video_url}</p>
                    <label>Caption (English)</label>
                    <input
                        type="text"
                        value={vid.en?.caption || ''}
                        onChange={(e) => updateCaption(index, 'en', e.target.value)}
                    />
                    <label>Caption (Hindi, optional)</label>
                    <input
                        type="text"
                        value={vid.hi?.caption || ''}
                        onChange={(e) => updateCaption(index, 'hi', e.target.value)}
                    />
                    <div className="ace-block-actions">
                        <button type="button" onClick={() => moveVideo(index, 'up')} disabled={index === 0}>↑</button>
                        <button type="button" onClick={() => moveVideo(index, 'down')} disabled={index === videos.length - 1}>↓</button>
                        <button type="button" onClick={() => removeVideo(index)}>🗑️ Remove</button>
                    </div>
                </div>
            ))}

            <div className="ace-form-actions">
                <button onClick={handleSave} disabled={saving}>{saving ? 'Saving...' : 'Save'}</button>
                <button onClick={onCancel} className="ace-cancel-btn">Cancel</button>
            </div>
        </div>
    );
};

export default VideoCarouselForm;